import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import QuizPage from '@/components/QuizPage/QuizPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: 'Школа ответственного владельца'
    }
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: QuizPage,
    meta: {
      title: 'Школа ответственного владельца'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Обработчик для изменения заголовка страницы
router.beforeEach((to, from, next) => {
  // Устанавливаем заголовок страницы
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Школа ответственного владельца'
  }
  next()
})

export default router
